import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappLink, DEFAULT_WA_MESSAGE } from "../data/site";

export const WhatsAppFloat = () => (
    <motion.a
        href={whatsappLink(DEFAULT_WA_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-button"
        aria-label="Scrivici su WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="wa-pulse fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-wa text-black flex items-center justify-center hover:scale-110 transition-transform duration-300"
    >
        <MessageCircle size={26} />
    </motion.a>
);
